import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatInputModule } from '@angular/material/input';
import { FormlyModule } from '@ngx-formly/core';
import { FormlySelectModule } from '@ngx-formly/core/select';

import {
  CastObservablePipe,
  FilterWithPipe,
} from '@lockton-apps/shared/ui/pipes';

import { AutocompleteTypeComponent } from './autocomplete-type.component';
import { SelectOptionsPipe } from '../pipes/select-options/select-options.pipe';

@NgModule({
  declarations: [AutocompleteTypeComponent],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    MatAutocompleteModule,
    MatInputModule,
    FormlySelectModule,
    FilterWithPipe,
    SelectOptionsPipe,
    FormlyModule.forChild({
      types: [
        {
          name: 'autocomplete',
          component: AutocompleteTypeComponent,
          wrappers: ['mat-form-field', 'addons'],
        },
        { name: 'enum', extends: 'select' },
      ],
    }),
    CastObservablePipe,
  ],
  providers: [SelectOptionsPipe],
})
export class AutocompleteTypeModule {}
